










































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Location } from "@/store/models";
import ChillIndex from "@/components/ChillIndex.vue";

import axios from "axios";
import moment, { Moment } from "moment";

@Component({
  components: {
    ChillIndex,
  },
})
export default class WeatherInfo extends Vue {
  @Prop() location: Location | undefined;

  forecasts = new Array<any>();

  mounted() {
    if (this.location) {
      this.getWeather();
    }
  }

  getWeather() {
    if (this.location) {
      const url = this.location._links.mapfeature.href;
      axios.get(`https://www.yr.no${url}`).then((response) => {
        const result = response.data;
        this.makeForcastInterval(result);
      });
    }
  }

  isNight(start: Moment, end: Moment) {
    if ((end.hour() == 0) || (end.hour() == 6)) {
      return true;
    }
    return false;
  }

  makeForcastInterval(result: any) {
    this.forecasts = new Array<any>();
    const forecastsRaw = new Array<any>();
    const tempArray = new Array<any>();
    /* 
    Procesamos la info de la api para construir objetos con los datos de clima
    para 6 hs de tiempo.
    */
    result.properties.forecast.forEach((element: any) => {
      const start = moment(element.start.substr(0, 19));
      const end = moment(element.end.substr(0, 19));
      const partOfDay = this.isNight(start, end) ? 'Noche' : 'Día'
      const _id = `${end.format("YYYYMMDD")}_${partOfDay}`;

      tempArray.push({
        id: _id,
        var: partOfDay,
        start: start.format("DD/MM/YYYY HH:mm"),
        end: end.format("DD/MM/YYYY HH:mm"),
        precipitation: element.precipitation.value,
        tempMin: element.temperature.min,
        tempMax: element.temperature.max,
        wind: element.wind.speed,
      });
    });
    // Buscamos agrupar los periodos de la noche y del día.
    const keys = new Set(tempArray.map((a) => a.id));
    // Para cada periodo de noche y dia, calculamos los datos del periodo entero. Son 2 periods 
    // de 6hs para la noche (de 18 a 6) y dos para el día (de 6 a 18).
    keys.forEach((key) => {
      const forecastTemp = {
        id: "",
        var: "",
        start: "",
        end: "",
        precipitation: 0,
        tempMin: 1000,
        tempMax: 0,
        wind: 0,
        counter: 0,
      };
      tempArray
        .filter((f) => f.id === key)
        .forEach((forecast) => {
          forecastTemp.id = forecast.id;
          forecastTemp.var = forecast.var;
          forecastTemp.start = forecastTemp.start == '' ? forecast.start: forecastTemp.start;
          forecastTemp.end = forecast.end;
          forecastTemp.precipitation += forecast.precipitation;
          forecastTemp.tempMin = Math.min(
            forecastTemp.tempMin,
            forecast.tempMin
          );
          forecastTemp.tempMax = Math.max(
            forecastTemp.tempMax,
            forecast.tempMax
          );
          forecastTemp.wind += forecast.wind;
          forecastTemp.counter += 1;
        });
      forecastsRaw.push(forecastTemp);
    });
    this.forecasts = forecastsRaw;
  }

}
